import styles from './ConnectivitySummaryVisualization.module.scss';
import {
    connectedColor,
    disconnectedColor,
} from 'store/services/device-status';
import { ConnectivitySummary } from 'types';
import {
    PercentageBarSegment,
    PercentageBarVisualization,
} from 'components/data/PercentageBarVisualization/PercentageBarVisualization';

export interface ConnectivitySummaryVisualizationProps {
    /** Connectivity information for the supplier's deployed devices. */
    connectivitySummary: ConnectivitySummary;
}

/** Connectivity data visualization for the supplier's deployed devices showing percentage of connected vs disconnected devices. */
export default function ConnectivitySummaryVisualization({
    connectivitySummary,
}: ConnectivitySummaryVisualizationProps) {
    const disconnected: PercentageBarSegment = {
        width:
            (connectivitySummary.disconnectedCount /
                (connectivitySummary.connectedCount +
                    connectivitySummary.disconnectedCount)) *
            100,
        backgroundColor: disconnectedColor,
        name: 'Disconnected',
        tooltip: `${connectivitySummary.disconnectedCount} disconnected devices`,
    };

    const connected: PercentageBarSegment = {
        width:
            (connectivitySummary.connectedCount /
                (connectivitySummary.connectedCount +
                    connectivitySummary.disconnectedCount)) *
            100,
        backgroundColor: connectedColor,
        name: 'Connected',
        tooltip: `${connectivitySummary.connectedCount} connected devices`,
    };

    return (
        <div className={styles.ConnectivitySummaryVisualization}>
            <PercentageBarVisualization
                testId="ConnectivitySummaryVisualization"
                label="Connectivity"
                percentageBarSegments={[connected, disconnected]}
            />
        </div>
    );
}
